import React from 'react';
import { Row, Col, Button } from 'antd';
import { connect } from 'react-redux'
import { ReactComponent as ImageOrTextIcon } from '../../resources/img/NewIcons/previewer/image_text.svg';

class SignatureQR extends React.Component {
  render() {
    const showImg = this.props.image.replace('data:image/png;base64,', '') === '' ? 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==' : this.props.image;
    return (
      <div style={{ padding: 10, marginBottom: 10, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <ImageOrTextIcon className='icon-menu' />
          <h2 className={'title'}>{this.props.title}</h2>
        </div>
        <div style={{ borderBottom: 'none', marginBottom: 10 }} />
        <Row gutter={16} className={'flexRight'} style={{ flex: 1 }}>
          <Col xs={24} md={10} lg={9} xl={7} style={{ textAlign: 'left', margin: 'auto' }}>
            <img style={{ width: 200, height: 200, marginBottom: 20 }} src={showImg} alt={"imgSignature"} />
          </Col>
          <Col xs={24} md={14} lg={15} xl={17} style={{ textAlign: 'left', margin: 'auto' }}>
            <p style={{ marginTop: '10px', textAlign: 'justify' }} className={'mb-10'}>{this.props.text}</p>
          </Col>
        </Row>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto' }}>
          <Button type={'primary rounded-m'} onClick={this.props.modalDismiss}>
            {this.props.textButton}
          </Button>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
    language: state.auth.language,
  };
};

export default connect(mapStateToProps, {})(SignatureQR);
